import { createContext, useContext, useEffect, useState } from "react";
import * as defaults from "./content";
import API from "./api";

const ContentContext = createContext(defaults);
const RefreshContext = createContext(() => {});

export function ContentProvider({ children }) {
  const [content, setContent] = useState(defaults);

  const refresh = async () => {
    try {
      const res = await fetch(`${API}/api/content`);
      const data = await res.json();
      // Server content (site text, weekend pricing, …) overrides the code
      // defaults — but the NAV is structural and lives in code: a stale
      // `nav` saved in the database must never shadow a shipped menu update.
      setContent(
        data && data.content
          ? { ...defaults, ...data.content, nav: defaults.nav }
          : defaults
      );
    } catch {
      setContent(defaults);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <RefreshContext.Provider value={refresh}>
      <ContentContext.Provider value={content}>{children}</ContentContext.Provider>
    </RefreshContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
export const useContentRefresh = () => useContext(RefreshContext);
